<template>
	<div class="home">
		<div class="top">
			<van-popup v-model="show" get-container="body" :style="{ height: '85%',width: '90%' }" :closeable="true">
				<div class="" >
					<div class="plr20 bggrey  ft28" style="height: 6vh; line-height: 6vh;">被访者信息</div>
					<van-cell-group class="plr20">
						<van-cell title="被访者姓名" :value="showForm.intervieweeName" />
						<van-cell title="被访者电话" :value="showForm.intervieweePhone" />
						<van-cell title="访问时间" :value="showForm.interviewTime" />
						<van-cell title="结束时间" :value="showForm.leaveTime" />
						<van-cell v-if="showForm.confirmTime" title="离矿时间" :value="showForm.confirmTime" />
					</van-cell-group>
					<div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh;">来访单位信息</div>
					<van-cell-group class="plr20">
						<van-cell title="来访单位" :value="showForm.company" />
						<van-cell title="车牌号" :value="showForm.carNo" />
						<van-cell title="来访事由" :value="showForm.reason" />
					</van-cell-group>
					<div class="plr20 bggrey  ft28" style="height: 6vh; line-height: 6vh;">访客信息</div>
					<div v-for="(item, index) in showForm.visitors" :key="index">
						<div class="bgwhite yellow2 ft30 pl30 bor-bt" style="height:5.5vh; line-height:5.5vh;">
							访客{{ index + 1 }}</div>
						<van-cell-group class="plr20">
							<van-cell title="访客姓名" :value="item.personName" />
							<van-cell title="身份证号" :value="item.personNo" />
							<van-cell title="访客电话" :value="item.personPhone" />
							<van-cell title="性别" :value="item.sex?'女':'男'" />
							<van-cell title="年龄" :value="item.age" />
							<van-cell title="出入卡" :value="item.hasPass==0 ? item.passNo:'无'" />
							<van-cell title="上岗证" :value="item.hasWorklicense==0 ? item.worklicenseNo:'无'" />
							<!--健康码改为附件20240721-->
							<div class="flex alstart between mt20">
								<span class="ft30 w40">附件</span>
								<template v-if="item.healthCode.indexOf(';')!=-1">
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" v-for="(i,v) in item.healthCode.split(';')" :key="v"
											:src="showForm.imgUrl+i"  @click="imagePreview(item,v,1)" style="display: flex; padding: 0 1vw 1vw 0;">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
								<template v-else>
									<div class="flex flex1 " style="flex-wrap: wrap;">
										<van-image width="20vw" height="20vw" :src="showForm.imgUrl+item.healthCode"  @click="imagePreview(item,0,1)" style="padding: 0 1vw 1vw 0;">
											<template v-slot:loading> 
												<van-loading type="spinner" size="20" />
											</template>
										</van-image>
									</div>
								</template>
							</div>			
							<!--健康码改为附件20240721-->
							<!--屏蔽掉健康码相关信息20240721-->
							<div v-if="$globalJKM">	
								<van-cell title="目前居住地" :value="item.apartment" />							
								<van-cell title="来杭交通方式" :value="item.transport" />
								<van-cell title="发热咳嗽" :value="item.hasCough?'是':'否'" />							
								<van-cell title="省内访客" :value="showForm.provinceInner?'否':'是'" />
								<div class="flex alstart between mt20">
									<span class="ft30 w40">健康码</span>
									<template v-if="item.healthCode.indexOf(';')!=-1">
										<div class="flex flex1 " style="flex-wrap: wrap;">
											<van-image width="20vw" height="20vw" v-for="(i,v) in item.healthCode.split(';')" :key="v"
												:src="showForm.imgUrl+i"  @click="imagePreview(item,v,1)" style="display: flex; padding: 0 1vw 1vw 0;">
												<template v-slot:loading> 
													<van-loading type="spinner" size="20" />
												</template>
											</van-image>
										</div>
									</template>
									<template v-else>
										<div class="flex flex1 " style="flex-wrap: wrap;">
											<van-image width="20vw" height="20vw" :src="showForm.imgUrl+item.healthCode"  @click="imagePreview(item,0,1)" style="padding: 0 1vw 1vw 0;">
												<template v-slot:loading> 
													<van-loading type="spinner" size="20" />
												</template>
											</van-image>
										</div>
									</template>
								</div>							
								<div class="flex alstart between mt20">
									<span class="ft30 w40">核酸检测报告</span>
									<template v-if="item.acidCode.indexOf(';')!=-1">
										<div class="flex flex1 " style="flex-wrap: wrap;">
											<van-image width="20vw" height="20vw" v-for="(i,v) in item.acidCode.split(';')" :key="v"
												:src="showForm.imgUrl+i"  @click="imagePreview(item,v,3)" style="display: flex;padding: 0 1vw 1vw 0;">
												<template v-slot:loading> 
													<van-loading type="spinner" size="20" />
												</template>
											</van-image>
										</div>
									</template>
									<template v-else>
										<div class="flex flex1 " style="flex-wrap: wrap;">
											<van-image width="20vw" height="20vw" :src="showForm.imgUrl+item.acidCode"  @click="imagePreview(item,0,3)" style="padding: 0 1vw 1vw 0;">
												<template v-slot:loading> 
													<van-loading type="spinner" size="20" />
												</template>
											</van-image>
										</div>
									</template>
								</div>
							</div>
						</van-cell-group>
					</div>
					<div class="tc ptb10">
						<van-button type="danger" class=" tc" @click="show = false">关闭</van-button>
					</div>
				</div>
			</van-popup>
			<div class="w100" style="height: 50px; position: fixed;z-index: 100; ">
				<van-search v-model="visitorName" show-action placeholder="请输入访客姓名或手机号" @search="onSearch">
					<template #action>
						<div @click="onSearch">搜索</div>
					</template>
				</van-search>
			</div>
			<div class="bggrey" style="height: 8vh;"></div>

			<van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh">
				<div class="autoFixed">
					<van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
						<van-cell v-for="(item, index) in checkedHistoryList" :key="index" style="margin-top: 20px; padding: 0">
							<div class="main">
								<div class="history-left" style="margin-top: 20px;">
									<div class="yellow"> 来访信息：</div>
									<div class="history-item">
										<span>被访对象姓名：</span>
										<span>{{ item.intervieweeName }}</span>
									</div>
									<div class="history-item">
										<span>被访对象手机号：</span>
										<span>{{ item.intervieweePhone }}</span>
									</div>
									<div class="history-item">
										<span>来访事由：</span>
										<span>{{ item.reason }}</span>
									</div>
									<div class="history-item">
										<span>来访时间：</span>
										<span>{{ item.interviewTime }}</span>
									</div>
									<div v-if="item.confirmTime" class="history-item">
										<span>离矿时间：</span>
										<span>{{ item.confirmTime }}</span>
									</div>
									<div class="history-item">
										<span>访客姓名：
											<span v-for="list,index1 in item.visitors" :key="index1">
												{{list.personName}}
												<span v-if="index1 < (item.visitors.length-1)&&item.visitors.length>1">、</span>
											</span>
										</span>
										<span>{{ item.personName }}</span>
									</div>
									<div class="yellow">领导审核：</div>
									<van-row class="bggrey p-box1 mtb20"
										v-for="(list, index1) in item.visitorCheckerList" :key="index1">
										<van-col class="p-label1" span="6">{{list.checkerName}}</van-col>
										<!-- <van-col class="p-value1" span="7">{{list.checkerPhone}}</van-col> -->
										<van-col class="p-value1" span="6" v-if="list.checkStatus==0">待审核
										</van-col>
										<van-col class="p-value1 blue" span="6"  @click="getRefuseReason(list)" v-if="list.checkStatus==1">通过
										</van-col>
										<van-col class="p-value1 red" span="6" @click="getRefuseReason(list)" v-if="list.checkStatus==2">拒绝
										</van-col>
										<van-col class="p-value1" span="12" v-if="list.checkTime">{{list.checkTime}}
										</van-col>
									</van-row>
								</div>
								<!-- <div class="hisotry-right"></div> -->

								<van-button plain type="info" size="small" class="userBtn" @click="getDetail(item)">详情
								</van-button>
							</div>
						</van-cell>
					</van-list>
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>
<script>
	// import tabs from "@/components/tabs.vue";
	import {
		guardApptQuery,
	} from "@/apis/api";
	import {
		Toast,
		Dialog,
		ImagePreview,
	} from "vant";
	import {
		formatTime
	} from "@/utils/index";
	export default {
		data() {
			return {
				checkedHistoryList: [],
				pageNo: 1,
				pageSize: 10,
				total: 0,
				isLoading: false,
				loading: false,
				finishedBottom: false,
				show: false,
				showForm: {},
				visitorName: '',
			};
		},
		mounted() {
			document.title = "门岗预约查询";
			this.onSearch();
		},
		methods: {
			imagePreview(item,list,index){
				var images,arr;
				if(index==1){
					if(item.healthCode.indexOf(';')!=-1){
						arr = item.healthCode.split(';');
						for(let i=0;i<arr.length;i++){
							arr[i] = this.showForm.imgUrl+arr[i]
						}
						images = arr;
					}else{
						images = [this.showForm.imgUrl+item.healthCode]
					}
					
				}else if(index==2){
					if(item.routeCode.indexOf(';')!=-1){
						arr = item.routeCode.split(';');
						for(let i=0;i<arr.length;i++){
							arr[i] = this.showForm.imgUrl+arr[i]
						}
						images = arr;
					}else{
						images = [this.showForm.imgUrl+item.routeCode]
					}
				}else if(index==3){
					if(item.acidCode.indexOf(';')!=-1){
						arr = item.acidCode.split(';');
						for(let i=0;i<arr.length;i++){
							arr[i] = this.showForm.imgUrl+arr[i]
						}
						images = arr;
					}else{
						images = [this.showForm.imgUrl+item.acidCode]
					}
				}
				console.log(images);
				ImagePreview({
				  images,
				  startPosition: list,
					closeable: true,
				});
			},
			// 详情
			getDetail(item) {
				this.show = true;
				this.showForm = item;
			},
			// 拒绝原因
			getRefuseReason(list){
				Dialog.alert({
				  title: '原因',
				  message: list.refuseReason,
				  theme: 'round-button',
				}).then(() => {
				});
			},
			// 搜索
			onSearch() {
				this.onRefresh(1);
			},
			onRefresh(index) {
				this.pageNo = 1;
				this.pageSize = 10;
				this.isLoading = true;
				this.loading = true;
				console.log(666);
				guardApptQuery({
					pageNo: this.pageNo,
					pageSize: this.pageSize,
					visitorName: this.visitorName,
				}).then(res => {
					this.isLoading = false;
					this.loading = false;
					if(res.code!==200){
						this.finishedBottom = true;
						Toast(res.message);
					}else{
						if (index != 1) {
							Toast('刷新成功');
						}
						this.checkedHistoryList = res.result.records;
						this.total = res.result.total;
						if (this.checkedHistoryList.length == this.total) {
							this.finishedBottom = true;
						}else{
							this.finishedBottom = false;
						}
					}
				});
			},
			onLoad(e) {
				if (this.isLoading) return;
				console.log('e');
				this.pageNo++;
				guardApptQuery({
					pageNo: this.pageNo,
					pageSize: this.pageSize,
					visitorName: this.visitorName,
				}).then(res => {
					if(res.code!==200){
						this.finishedBottom = true;
						Toast(res.message);
					}else{
						this.isLoading = false;
						this.loading = false;
						this.checkedHistoryList = this.checkedHistoryList.concat(res.result.records);
						if (this.checkedHistoryList.length == this.total) {
							this.finishedBottom = true;
						}
					}
					
				});
			},

		},
		// components: {
		// 	tabs,
		// },
	};
</script>

<style lang="less" scoped>
	.modals {
		// padding: 10px 30px;
	}

	.autoFixed {
		background: #f3f3f3;
		min-height: 100vh;
		padding: 0 20px;
		position: relative;

		.userBtn {
			position: absolute;
			right: 20px;
			top: 20px;
			width: 94px;
			height: 40px;
			text-align: center;
			line-height: 40px;

			background: none;
			border-radius: 5px;
			color: #4597FF;
		}

		.main {
			box-sizing: content-box;
			background: #ffffff;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			width: 100%;
			border-radius: 5px;
			padding: 0 24px;
			box-sizing: border-box;
			position: relative;

			.roomName {
				position: absolute;
				left: 20px;
				top: 20px;
				color: #64b0ff;
				font-weight: bold;
			}

			.hisotry-right {
				img {
					width: 150px;
					height: 130px;
				}
			}

			.history-item {
				margin-bottom: 15px;

				span {
					font-size: 28px;
					color: #333;
				}
			}
		}
	}
</style>
